var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalaccident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 170,
    viewBox: "0 0 172 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.531 79.5987C173.847 59.2507 166.967 38.8195 152.528 24.3046C145.421 17.1756 135.712 10.4395 122.81 7.19042C86.6288 -1.92201 63.1753 6.43483 51.4523 28.5963C39.7293 50.7578 6.09033 46.9459 0.725626 85.1788C-4.63907 123.412 21.3797 165.453 65.4685 167.746C109.557 170.039 103.883 148.101 128.001 138.678C146.449 131.478 168.089 109.958 171.531 79.5987Z",
    fill: "#EDFAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_460_2818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.445 122.792C106.72 126.568 104.1 129.784 100.376 130.204H100.239C99.8248 130.204 99.411 130.204 98.9973 130.204C95.8253 129.924 93.2049 127.407 92.9291 124.051V123.771L90.3087 94.8242L89.895 90.2095L89.6191 88.1119V87.5525L103.135 86.2939L103.273 88.2517L103.411 90.3493L106.307 122.653C106.445 122.653 106.445 122.653 106.445 122.792Z",
    fill: "#1A8099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.7243 88.1123L76.3798 113.563H74.0353L73.3457 88.1123H78.7243Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.411 85.7354H81.3438V101.118H90.9977C93.4802 101.118 95.411 99.1601 95.411 96.6429V85.7354Z",
    fill: "#006F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.688 118.598C87.8259 122.374 84.7918 125.45 81.206 125.59H81.0681C77.3444 125.73 74.3103 122.653 74.1724 119.018L74.0345 113.564L73.3449 88.1128L73.207 82.3793L86.7226 82.0996L87.688 118.598Z",
    fill: "#006F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5526 93.7055C75.2768 94.2649 74.3114 94.4047 73.7597 93.9852C72.2426 92.8664 71.0014 91.3282 70.1739 89.6501C69.7602 88.9509 70.1739 88.1119 70.7256 87.8322C71.4152 87.5525 71.9668 87.972 72.2426 88.5314C72.9322 89.9298 73.8976 91.1884 75.1388 92.0274C75.6905 92.3071 75.9663 93.1461 75.5526 93.7055Z",
    fill: "url(#paint0_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6867 159.012C95.6867 159.711 96.2384 160.13 96.7901 160.13H112.65C114.443 159.99 114.167 158.173 114.167 158.173C114.029 156.634 111.133 155.096 109.616 154.397L105.065 152.02L95.5488 152.719L95.6867 159.012Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.375 152.998L99.824 153.557L94.8591 153.977L92.9283 124.051V123.771C92.6525 120.415 94.997 117.339 98.169 116.64C98.4449 116.5 98.8586 116.5 99.1344 116.5H99.2723C102.858 116.22 106.03 118.877 106.444 122.513V122.653L108.375 152.998Z",
    fill: "#1A8099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.066 153.558L94.8597 153.977L92.929 124.051V123.772L90.3086 94.8247L95.4114 88.1123L98.1697 116.64L98.7213 122.233L101.066 153.558Z",
    fill: "#006F8F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.411 90.2099H73.3457V88.1123H103.273L103.411 90.2099Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.069 113.983C87.9652 116.64 88.1031 120.835 85.6207 123.632L65.7611 146.286L55.6934 137.056L75.553 114.402C78.0354 111.745 82.3108 111.465 85.069 113.983Z",
    fill: "#006F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8288 140.692C70.8634 141.811 71.0014 143.349 72.1047 144.328C77.4833 149.363 72.2426 156.215 67.1398 154.397C66.3123 154.117 65.4848 153.698 64.7952 152.859L63.554 151.74L57.3479 146.286C53.9 143.769 53.2105 139.014 57.072 134.819L59.0028 132.582L64.7952 125.869L72.9322 116.36C73.3459 115.801 74.1734 115.661 74.725 115.941C74.863 115.941 75.0009 116.08 75.0009 116.22L84.2411 124.331C84.7928 124.751 84.7928 125.59 84.379 126.149L71.8288 140.692Z",
    fill: "url(#paint1_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.552 120.136L70.5876 118.737L70.1738 119.297L80.5174 120.975L79.552 120.136Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6898 126.848L66.1747 124.051L65.623 124.61L83.1381 127.407L83.6898 126.848Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1371 132.162L61.622 129.365L61.0703 129.925L78.7233 132.722L79.1371 132.162Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7249 137.336L57.2099 134.539L56.934 134.819C56.7961 134.959 56.7961 135.099 56.6582 135.238L74.1733 138.035L74.7249 137.336Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2767 142.93L54.4512 140.133C54.4512 140.413 54.4512 140.553 54.4512 140.832L71.5525 143.629C71.4146 143.349 71.2767 143.07 71.2767 142.93Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3103 149.083L57.209 146.426L58.1744 147.265L74.1724 149.782C74.3103 149.642 74.3103 149.363 74.3103 149.083Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1037 153.558L63.9668 152.299L64.7943 152.998L64.9322 153.138L71.1383 154.117C71.5521 153.977 71.8279 153.837 72.1037 153.558Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.7942 116.221L64.5193 125.87L63.416 151.88L64.6572 152.999C65.4847 153.698 66.1743 154.257 67.0018 154.537L68.3809 121.534C71.2771 120.695 73.2079 118.458 74.4491 116.081C74.0354 115.521 73.2079 115.661 72.7942 116.221Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.823 70.3523L110.306 71.0515C107.548 71.6109 104.514 67.975 103.273 65.1782L103.135 64.8986L101.756 61.5424L95.6873 46.8591C94.4461 43.9225 95.8252 40.7061 98.7214 39.4475H98.8593C99.8247 39.028 100.928 38.8882 102.031 39.028C103.273 39.3077 104.514 40.0069 105.341 40.9858C105.617 41.4053 106.031 41.8248 106.169 42.3842L113.754 60.7033C113.892 60.983 114.168 62.1017 114.857 63.9197C115.271 66.5766 114.306 68.8141 111.823 70.3523Z",
    fill: "#F25A23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.962 40.0067V88.1119H73.207V39.727C74.7241 38.6083 78.034 37.7692 81.8956 37.3497C82.3094 37.3497 82.7231 37.2099 83.1368 37.2099C83.6885 37.2099 84.3781 37.07 85.0676 37.07C85.3435 37.07 85.6193 37.07 85.8951 37.07C89.343 36.9302 93.0666 37.07 96.2387 37.4895C97.2041 37.6294 98.1695 37.7692 99.1349 38.0489C101.066 38.4684 102.859 39.1676 103.962 40.0067Z",
    fill: "#F25A23"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.756 71.4709C105.756 72.4498 105.066 73.149 104.101 73.149H82.3105C79.966 72.8693 78.0352 70.9116 78.0352 68.5343V65.4578C78.0352 63.0805 79.828 61.1227 82.0347 60.843L81.8967 37.4896C82.3105 37.4896 82.7242 37.3498 83.138 37.3498C83.6896 37.3498 84.3792 37.21 85.0688 37.21L90.0337 55.3892L94.8607 38.6084C94.9986 38.6084 95.1365 38.6084 95.4123 38.7482C96.1019 38.888 96.9294 39.0279 97.6189 39.1677H97.7569L98.0327 60.7032H104.101C105.066 60.7032 105.756 61.4024 105.756 62.3813C106.445 65.4578 106.308 68.3944 105.756 71.4709Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1014 29.6592V37.7699C95.4118 41.2659 86.7232 41.2659 85.7578 37.7699V29.6592H96.1014Z",
    fill: "#F0AB6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9281 72.0305H83.5505L83.1367 37.2102H83.2746C83.9642 37.2102 84.7917 37.0703 85.4813 37.0703C85.6192 37.0703 85.7571 37.0703 85.7571 37.0703L90.722 52.4528L96.9281 72.0305Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90.8613 31.3367L89.62 31.4765L89.0684 31.1969L90.8613 30.7773L92.6541 31.1969L92.2404 31.4765L90.8613 31.3367Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M96.1021 29.2393V35.5321C94.8609 36.7907 93.6197 37.0703 91.6889 37.0703H91.413C91.2751 37.0703 91.1372 37.0703 90.9993 37.0703C90.8614 37.0703 90.7235 37.0703 90.5856 37.0703H90.3097C88.3789 37.0703 87.1377 36.7907 85.8965 35.5321V29.2393H96.1021Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0344 71.6107C86.1723 71.6107 86.4481 71.6107 86.5861 71.6107L108.652 71.4708C111.686 71.4708 114.169 68.9537 114.169 65.7374V65.5975C114.169 62.521 111.686 60.0039 108.514 60.0039L86.4481 60.1437C86.3102 60.1437 86.0344 60.1437 85.8965 60.1437L86.0344 71.6107Z",
    fill: "#F25A23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.479 72.0308H83.9645C81.3441 72.0308 79.2754 69.9332 79.2754 67.2762V64.3395C79.2754 61.6826 81.3441 59.585 83.9645 59.585H105.479C106.444 59.585 107.134 60.2842 107.134 61.263C107.686 64.3395 107.548 67.2762 107.134 70.3527C107.134 71.3316 106.307 72.0308 105.479 72.0308Z",
    fill: "url(#paint2_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.793 60.8433L82.4479 71.7509C82.7238 71.8908 82.8617 71.8908 83.1375 71.8908L81.4825 60.4238C81.2067 60.5637 80.9309 60.7035 80.793 60.8433Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4824 59.585L87.2753 72.0308H87.9649L86.0341 59.585H85.4824Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3086 59.585L92.1015 72.0308H92.6531L90.8603 59.585H90.3086Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1367 59.585L96.9296 72.0308H97.4813L95.6884 59.585H95.1367Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8242 59.585L101.755 72.0308H102.307L100.514 59.585H99.8242Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.996 70.7722L105.341 59.585H104.789L106.582 71.6113C106.72 71.3316 106.858 71.1917 106.996 70.7722Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M96.9284 72.0308H86.0332L90.7223 52.4531L96.9284 72.0308Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.6553 37.35L85.3449 44.4819L84.1036 37.4898V45.3209L83.6899 40.2866L83.4141 37.2102C84.1036 37.2102 84.9311 37.0703 85.6207 37.0703L86.9998 43.0835L84.6553 37.35Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4109 72.0309H86.0332L96.1009 37.4902C96.2389 37.4902 96.3768 37.4902 96.6526 37.6301C97.3422 37.7699 98.1696 37.9098 98.8592 38.0496H98.9971L99.4109 72.0309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.7213 37.9097L98.4454 40.9862L97.8938 46.1603V38.3292L96.6526 45.3212L97.3421 38.1894L95.2734 44.0627L96.6526 37.7698C97.3421 37.63 98.0317 37.7698 98.7213 37.9097Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.5511 53.432L73.207 53.1523V57.9069L76.1032 58.0468C75.9653 61.4029 73.8966 74.1284 73.207 86.2946C73.207 86.8539 73.207 87.5531 73.207 88.1125H77.2065C77.8961 75.5268 78.5857 61.6826 78.7236 58.0468H79.2752C80.9302 58.1866 82.3094 57.0679 82.4473 55.8093C82.4473 54.5508 81.206 53.432 79.5511 53.432Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2917 92.332L60.127 95.9639L77.7605 96.7862L77.9253 93.1543L60.2917 92.332Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8276 121.675H67.6897C60.5182 120.416 59.139 112.026 59.2769 107.691C59.0011 101.258 60.9319 56.7886 61.0698 54.9707L63.8281 55.1105C63.8281 55.5301 61.7594 101.258 62.0352 107.691C62.0352 107.83 61.6215 117.619 67.9655 118.878C74.3096 118.179 74.8612 108.53 74.8612 108.25C75.6887 101.817 77.7574 56.0894 77.8953 55.6699L80.6536 55.8097C80.5157 57.6277 78.447 102.097 77.6195 108.53C77.4816 112.865 75.137 121.115 67.9655 121.675H67.8276Z",
    fill: "url(#paint3_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8287 121.255L65.8979 121.115L64.3809 155.796L66.3117 155.936L68.2424 156.075L69.7595 121.395L67.8287 121.255Z",
    fill: "url(#paint4_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2415 156.075L66.3107 155.935L64.3799 155.795L63.1387 160.13H69.2069L68.2415 156.075Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3806 55.8093C58.7256 55.6694 57.4844 54.5507 57.4844 53.2921C57.4844 52.0336 59.0014 51.0547 60.6564 51.0547L81.3435 52.0336C82.9985 52.1734 84.2397 53.2921 84.2397 54.5507C84.2397 55.8093 82.7226 56.7882 81.0677 56.7882L60.3806 55.8093Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6198 46.0205L77.0687 60.564L75.6895 64.6193L75.5516 64.899C74.5862 67.8357 71.4142 69.5138 68.518 68.5349H68.3801C65.7597 67.6958 64.2426 65.1787 64.5185 62.5217C64.5185 62.1022 64.6564 61.8225 64.7943 61.403L70.8625 42.3847C71.1383 41.6855 71.4142 41.1261 71.8279 40.5668C72.5175 39.5879 73.6208 39.0285 74.7241 38.609C75.6895 38.3293 76.7928 38.3293 77.8961 38.7488H78.034C80.9302 39.8675 82.5852 43.0839 81.6198 46.0205Z",
    fill: "#F25A23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8611 36.0917C90.7232 36.0917 90.5853 36.0917 90.4473 36.0917H90.1715C86.5857 36.0917 85.4824 34.973 81.8967 29.3794C80.9313 27.981 80.5175 25.6037 80.2417 22.9467C79.9659 22.9467 79.69 22.9467 79.4142 22.667C78.8626 22.2475 78.3109 21.1288 78.173 20.01C77.8972 18.1921 78.3109 16.514 79.1384 16.3742C79.4142 16.3742 79.69 16.514 79.9659 16.6539C80.3796 17.6328 80.6554 18.7515 80.6554 19.7304C80.9313 19.7304 80.7934 19.4507 80.9313 19.4507C78.7246 3.50886 85.6203 4.62758 89.2061 4.62758C89.2061 4.62758 90.999 4.76742 90.999 4.62758C90.999 4.62758 92.7919 4.48774 92.7919 4.62758C96.3776 4.62758 103.273 3.6487 101.067 19.4507C101.205 19.5905 100.929 19.7304 101.343 19.7304C101.343 18.6116 101.618 17.6328 102.032 16.6539C102.308 16.3742 102.584 16.3742 102.86 16.3742C103.687 16.514 104.101 18.1921 103.825 20.01C103.549 21.2686 103.135 22.2475 102.584 22.667C102.308 22.9467 102.032 23.0865 101.756 22.9467C101.48 25.6037 100.929 27.981 100.101 29.3794C96.5156 34.8332 95.2743 36.0917 91.8265 36.0917H91.5507C91.2748 36.0917 90.999 36.0917 90.8611 36.0917Z",
    fill: "url(#paint5_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.2057 17.633C89.2057 18.1924 87.9645 18.8916 86.3095 19.0314C84.7924 19.1713 83.4133 18.7517 83.2754 18.1924C83.2754 17.633 85.6199 16.6541 87.2749 16.3744C88.9299 16.2346 89.2057 16.9338 89.2057 17.633Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.6543 17.633C92.6543 18.1924 93.8955 18.8916 95.5505 19.0314C97.2054 19.1713 98.5846 18.8916 98.5846 18.3322C98.5846 17.7729 96.2401 16.794 94.5851 16.5143C92.9301 16.2346 92.6543 16.9338 92.6543 17.633Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M90.8608 27.5612L89.4817 27.2816C89.068 27.1417 88.6542 27.2816 88.2405 27.4214C87.6888 27.7011 86.8613 27.9808 86.8613 27.9808C86.8613 27.9808 86.8613 27.9808 86.8613 28.1206C86.8613 28.1206 86.8613 28.1206 86.9992 28.1206H87.413L87.6888 29.519L87.2751 30.0784C87.9646 29.9385 87.9646 29.7987 88.3784 29.7987L90.9988 29.519L93.6191 29.7987C94.0329 29.7987 94.0329 30.0784 94.7224 30.0784L94.3087 29.519L94.5845 28.1206H94.9983H95.1362V27.9808C95.1362 27.9808 94.3087 27.5612 93.757 27.4214C93.3433 27.2816 92.9295 27.1417 92.5158 27.2816L90.8608 27.5612Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.516 17.9127C88.516 18.3322 87.5506 18.8916 86.3094 19.0314C85.0682 19.1713 83.9648 18.8916 83.9648 18.4721C83.9648 18.0525 85.7577 17.2135 86.9989 17.0737C88.2402 16.9338 88.516 17.4932 88.516 17.9127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3438 17.9127C93.3438 18.3322 94.3091 18.8916 95.5504 19.0314C96.7916 19.1713 97.8949 18.8916 97.8949 18.4721C97.8949 18.0525 96.102 17.2135 94.8608 17.0737C93.6196 16.9338 93.3438 17.4932 93.3438 17.9127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9299 15.8148C88.9299 15.9547 88.9299 15.9547 88.9299 15.8148C88.9299 15.9547 88.9299 16.0945 88.7919 16.0945L83.2754 17.6328C83.1375 17.6328 83.1375 17.6328 83.1375 17.6328C83.1375 17.6328 82.9996 17.4929 83.1375 17.4929C83.1375 17.2132 83.4133 16.9336 83.6891 16.9336L87.6886 15.5352C88.1024 15.2555 88.654 15.3953 88.9299 15.8148Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9297 15.8148C92.9297 15.9547 92.9297 15.9547 92.9297 15.8148C92.9297 15.9547 92.9297 16.0945 93.0676 16.0945L98.5841 17.6328C98.7221 17.6328 98.7221 17.6328 98.7221 17.6328C98.7221 17.6328 98.86 17.4929 98.7221 17.4929C98.7221 17.2132 98.4462 16.9336 98.1704 16.9336L94.1709 15.5352C93.7572 15.2555 93.2055 15.3953 92.9297 15.8148Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2741 18.0519C87.2741 18.4715 86.8604 18.891 86.4466 18.891C86.0329 18.891 85.6191 18.4715 85.6191 18.0519C85.6191 17.6324 86.0329 17.2129 86.4466 17.2129C86.8604 17.2129 87.2741 17.6324 87.2741 18.0519Z",
    fill: "#68B4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.584 18.0519C94.584 18.4715 94.9977 18.891 95.4115 18.891C95.8252 18.891 96.2389 18.4715 96.2389 18.0519C96.2389 17.6324 95.8252 17.2129 95.4115 17.2129C94.8598 17.2129 94.584 17.6324 94.584 18.0519Z",
    fill: "#68B4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8607 18.0523C86.8607 18.332 86.7228 18.4719 86.4469 18.4719C86.1711 18.4719 86.0332 18.332 86.0332 18.0523C86.0332 17.7727 86.1711 17.6328 86.4469 17.6328C86.7228 17.7727 86.8607 17.9125 86.8607 18.0523Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.998 18.0523C94.998 18.332 95.136 18.4719 95.4118 18.4719C95.6876 18.4719 95.8255 18.332 95.8255 18.0523C95.8255 17.7727 95.6876 17.6328 95.4118 17.6328C95.136 17.7727 94.998 17.9125 94.998 18.0523Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0326 17.9127C86.0326 18.1924 85.8947 18.3322 85.6188 18.3322C85.343 18.3322 85.2051 18.1924 85.2051 17.9127C85.2051 17.633 85.343 17.4932 85.6188 17.4932C85.8947 17.4932 86.0326 17.7728 86.0326 17.9127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1012 18.3322C96.3297 18.3322 96.515 18.1444 96.515 17.9127C96.515 17.681 96.3297 17.4932 96.1012 17.4932C95.8727 17.4932 95.6875 17.681 95.6875 17.9127C95.6875 18.1444 95.8727 18.3322 96.1012 18.3322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.413 18.3314C87.413 18.4713 87.2751 18.6111 87.1372 18.6111C86.9992 18.6111 86.8613 18.4713 86.8613 18.3314C86.8613 18.1916 86.9992 18.0518 87.1372 18.0518C87.2751 18.0518 87.413 18.1916 87.413 18.3314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4453 18.3314C94.4453 18.4713 94.5832 18.6111 94.7211 18.6111C94.8591 18.6111 94.997 18.4713 94.997 18.3314C94.997 18.1916 94.8591 18.0518 94.7211 18.0518C94.5832 18.0518 94.4453 18.1916 94.4453 18.3314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.861 25.1844C89.7577 25.0445 89.0682 24.9047 88.3786 24.4852C88.1028 24.3453 87.9648 23.9258 87.9648 23.5063L88.1028 22.9469C88.1028 22.8071 88.2407 22.8071 88.2407 22.6673L88.9302 22.3876C89.0682 22.3876 89.0682 22.2477 89.0682 22.2477L89.6198 16.7939L89.344 22.6673C89.344 22.6673 89.344 22.8071 89.2061 22.8071L88.6544 23.0868C88.5165 23.2266 88.3786 23.3665 88.3786 23.5063V23.786C88.3786 23.9258 88.5165 24.2055 88.6544 24.2055L90.7231 24.4852L92.7918 24.2055C92.9297 24.2055 93.0677 24.0657 93.0677 23.786V23.5063C93.0677 23.3665 92.9297 23.2266 92.7918 23.0868L92.2402 22.8071L92.1023 22.6673L92.2402 16.7939L92.7918 22.2477C92.7918 22.3876 92.7918 22.3876 92.9298 22.3876L93.4814 22.6673C93.6193 22.6673 93.6193 22.8071 93.6193 22.9469L93.7572 23.5063C93.8951 23.9258 93.7572 24.3453 93.3435 24.4852C92.7918 25.0445 92.1023 25.1844 90.861 25.1844Z",
    fill: "url(#paint6_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.7223 33.1547L84.7915 30.7774C84.6535 30.6376 84.5156 30.3579 84.5156 30.2181V29.0994C84.5156 28.8197 84.5156 28.54 84.6535 28.2603L85.3431 26.4424L84.9294 28.54C84.9294 28.6798 84.9294 28.8197 84.9294 28.9595L85.0673 30.0782C85.0673 30.3579 85.2052 30.6376 85.3431 30.9173L86.7223 33.1547Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.4121 33.0151L97.205 30.6378C97.3429 30.498 97.4808 30.2183 97.4808 30.0784V28.9597C97.4808 28.68 97.4808 28.4003 97.3429 28.1207L96.6533 26.3027L97.0671 28.4003C97.0671 28.5402 97.0671 28.68 97.0671 28.8199L96.9292 29.9386C96.9292 30.2183 96.7913 30.498 96.6533 30.7776L95.4121 33.0151Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8595 29.0992L87.8254 29.6586L87.6875 28.2602L90.8595 27.9805L94.1695 28.2602L93.8936 29.6586L90.8595 29.0992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.2754 22.667C79.5512 22.8068 79.827 22.8068 80.1029 22.9467C79.827 23.0865 79.5512 22.9467 79.2754 22.667Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.445 22.667C102.169 22.8068 101.893 22.8068 101.617 22.9467C101.893 23.0865 102.169 22.9467 102.445 22.667Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.134 10.2211C103.134 12.3187 102.858 14.4163 102.72 16.2342C101.617 16.0944 101.203 18.6115 101.203 19.5904C101.065 19.5904 100.927 19.5904 100.789 19.5904H100.651C100.927 18.0521 100.927 16.6537 101.065 15.3952V15.2553C101.203 7.84377 97.8931 6.72505 95.2728 6.72505C94.859 6.72505 93.7557 6.86489 93.0661 6.86489C93.342 7.14457 94.3074 7.28441 94.4453 7.42425C94.1695 7.42425 92.2387 7.42425 92.1007 7.42425C92.3766 7.70393 92.7903 7.84377 93.2041 7.98361C93.7557 8.12345 94.0315 8.26329 94.1695 8.26329H94.0315C93.6178 8.26329 92.5145 8.40313 88.6529 7.70393C85.205 7.14457 80.2401 4.4876 80.3781 14.2764C80.3781 15.6748 80.516 17.4928 80.7918 19.4505H80.6539C80.516 19.4505 80.3781 19.4505 80.3781 19.4505C80.3781 18.3318 79.9643 15.9545 78.861 16.0944C78.7231 14.2764 78.4473 12.1788 78.4473 10.0812C78.4473 8.82265 78.4473 7.70393 78.7231 6.5852C79.2748 4.90712 80.516 2.94935 82.033 1.83062C83.4122 0.851739 84.6534 0.572058 86.4463 0.292377C87.9633 0.152536 89.3425 0.0126953 90.8595 0.0126953C92.3766 0.0126953 93.8936 0.152536 95.2728 0.432217C96.9277 0.711898 98.3069 0.99158 99.686 1.97046C101.203 2.94935 102.582 5.04696 102.858 6.86489C103.134 7.84377 103.272 9.10234 103.134 10.2211Z",
    fill: "url(#paint7_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.2393 8.40304C93.3426 9.24208 94.5838 9.38192 94.308 9.38192C94.0322 9.38192 93.2047 9.66161 88.7914 8.82256C85.4815 8.2632 80.6545 5.74607 80.5166 14.4162C80.2408 4.62734 85.3436 7.28431 88.7914 7.84368C92.653 8.54288 93.7563 8.40304 94.1701 8.40304C94.308 8.40304 94.5838 8.40304 94.5838 8.54288C94.308 8.40304 92.2393 8.40304 92.2393 8.40304Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.066 15.2549C100.928 8.82222 97.756 7.70349 95.2736 7.70349C94.8598 7.70349 93.7565 7.84333 93.067 7.84333L93.2049 7.98317C92.929 7.84333 92.5153 7.70349 92.1016 7.42381C92.2395 7.42381 94.1703 7.56365 94.4461 7.42381C94.3082 7.42381 93.3428 7.28397 93.067 6.86445C93.7565 6.86445 94.8598 6.72461 95.2736 6.72461C98.0319 6.72461 101.204 7.98317 101.066 15.2549Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.4473 18.8916C78.4473 18.8916 78.4473 18.7517 78.4473 18.6119C78.4473 18.472 78.4473 18.1924 78.4473 17.9127C78.4473 17.7728 78.5852 17.4932 78.861 17.4932C78.9989 17.4932 79.1368 17.4932 79.2747 17.633C79.4127 17.7728 79.4127 17.7728 79.4127 17.9127C79.5506 18.1924 79.6885 18.6119 79.8264 19.0314C79.9643 19.7306 80.1022 20.5697 80.1022 21.129C80.1022 21.4087 79.9643 21.6884 79.9643 21.8282C79.8264 21.9681 79.8264 22.1079 79.8264 22.1079C79.8264 22.1079 79.9643 21.9681 79.9643 21.8282C79.9643 21.6884 79.9643 21.4087 79.9643 21.129C79.9643 20.5697 79.8264 19.8705 79.5506 19.0314C79.2747 18.6119 79.2747 18.1924 78.9989 17.9127C78.861 17.7728 78.861 17.633 78.7231 17.633C78.7231 17.633 78.5852 17.7728 78.5852 17.9127C78.4473 18.472 78.4473 18.8916 78.4473 18.8916Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.272 18.8916C103.272 18.8916 103.272 18.7517 103.272 18.6119C103.272 18.472 103.272 18.1924 103.272 17.9127C103.272 17.7728 103.134 17.4932 102.858 17.4932C102.72 17.4932 102.583 17.4932 102.445 17.633C102.307 17.7728 102.307 17.7728 102.307 17.9127C102.169 18.1924 102.031 18.6119 101.893 19.0314C101.755 19.7306 101.617 20.5697 101.617 21.129C101.617 21.4087 101.755 21.6884 101.755 21.8282C101.893 21.9681 101.893 22.1079 101.893 22.1079C101.893 22.1079 101.755 21.9681 101.755 21.8282C101.755 21.6884 101.755 21.4087 101.755 21.129C101.755 20.5697 101.893 19.8705 102.169 19.0314C102.307 18.6119 102.307 18.3322 102.583 18.0525C102.72 17.9127 102.72 17.7728 102.858 17.7728C102.858 17.7728 102.996 17.9127 102.996 18.0525C103.272 18.472 103.272 18.8916 103.272 18.8916Z",
    fill: "#704528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5533 85.4549L71.2775 88.3915L65.623 87.8322L65.761 84.8955L71.5533 85.4549Z",
    fill: "url(#paint8_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1756 99.4393C65.486 99.4393 65.0723 98.88 65.0723 98.1808L65.486 93.7059C65.486 93.0067 66.0377 92.5871 66.7272 92.727C67.4168 92.727 67.8305 93.2863 67.8305 93.9855L67.4168 98.4604C67.2789 99.0198 66.7272 99.4393 66.1756 99.4393Z",
    fill: "url(#paint9_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.106 98.1808C63.5544 98.1808 63.1406 97.6215 63.1406 97.0621L63.4165 93.1465C63.4165 92.5872 63.9681 92.1677 64.5198 92.3075C65.0714 92.3075 65.4852 92.8669 65.4852 93.4262L65.2093 97.3418C65.0714 97.9011 64.6577 98.3207 64.106 98.1808Z",
    fill: "url(#paint10_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5193 99.579C67.8298 99.579 67.416 99.0196 67.416 98.3204L67.8298 93.8455C67.8298 93.1463 68.3814 92.7268 69.071 92.8666C69.7606 92.8666 70.1743 93.426 70.1743 94.1252L69.7606 98.6001C69.6226 99.1595 69.071 99.7188 68.5193 99.579Z",
    fill: "url(#paint11_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7264 99.8593C70.0368 99.8593 69.623 99.2999 69.623 98.6007L70.0368 94.1258C70.0368 93.4266 70.5884 93.0071 71.278 93.1469C71.9676 93.1469 72.3813 93.7063 72.3813 94.4055L71.9676 98.8804C71.9676 99.4397 71.4159 99.8593 70.7264 99.8593Z",
    fill: "url(#paint12_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5183 93.8457L72.3804 94.6847C72.3804 95.3839 71.8288 95.8035 71.1392 95.6636C70.4496 95.6636 70.0359 95.1043 70.0359 94.4051C70.0359 95.1043 69.4842 95.5238 68.7947 95.3839C68.1051 95.3839 67.6914 94.8246 67.6914 94.1254C67.6914 94.8246 67.1397 95.2441 66.4501 95.1043C65.7606 95.1043 65.3468 94.5449 65.3468 93.8457L65.4847 93.0067C65.4847 93.566 64.9331 93.9855 64.3814 93.8457C63.8298 93.8457 63.416 93.2863 63.416 92.727L63.6918 89.231V88.9513C63.6918 88.8114 63.8298 87.5529 65.071 86.8537C65.2089 86.7138 65.3468 86.7138 65.4847 86.574L65.6226 84.6162L71.2771 85.1756L71.1392 87.1333C71.415 87.2732 71.5529 87.5529 71.8288 87.6927C72.2425 88.2521 72.5183 88.9513 72.5183 89.6505V89.7903V89.9302V93.8457Z",
    fill: "url(#paint13_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.5183 93.8457L72.3804 94.6847C72.3804 95.3839 71.8288 95.8035 71.1392 95.6636C70.4496 95.6636 70.0359 95.1043 70.0359 94.4051C70.0359 95.1043 69.4842 95.5238 68.7947 95.3839C68.1051 95.3839 67.6914 94.8246 67.6914 94.1254C67.6914 94.8246 67.1397 95.2441 66.4501 95.1043C65.7606 95.1043 65.3468 94.5449 65.3468 93.8457L65.4847 93.0067C65.4847 93.566 64.9331 93.9855 64.3814 93.8457C63.8298 93.8457 63.416 93.2863 63.416 92.727L63.6918 89.231V88.9513C63.6918 88.8114 63.8298 87.5529 65.071 86.8537C65.2089 86.7138 65.3468 86.7138 65.4847 86.574L65.6226 84.6162L71.2771 85.1756L71.1392 87.1333C71.415 87.2732 71.5529 87.5529 71.8288 87.6927C72.2425 88.2521 72.5183 88.9513 72.5183 89.6505V89.7903V89.9302V93.8457Z",
    fill: "url(#paint14_linear_460_2818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6914 86.5739C63.6914 86.434 63.6914 86.1544 63.6914 86.0145L64.5189 63.64C64.6568 60.5635 67.2772 58.0464 70.3113 58.1862H70.4492C73.4833 58.3261 75.9657 60.983 75.8278 64.0595L75.0004 86.434C75.0004 86.5739 75.0004 86.8536 75.0004 86.9934L63.6914 86.5739Z",
    fill: "#F25A23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_2818",
    x1: 73.8319,
    y1: 90.1908,
    x2: 71.7073,
    y2: 91.9081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0026512,
    stopColor: "#E6A770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1186,
    stopColor: "#E9B27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#EBB987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    stopColor: "#EBBB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#EBBA88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#E9B481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9754,
    stopColor: "#E7AB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_460_2818",
    x1: 62.4271,
    y1: 127.507,
    x2: 80.7143,
    y2: 144.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0728563,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2168,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5574,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6902,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_460_2818",
    x1: 93.4012,
    y1: 72.0348,
    x2: 93.4012,
    y2: 59.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0728563,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2168,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9198,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_460_2818",
    x1: 59.2185,
    y1: 88.3737,
    x2: 80.6364,
    y2: 88.3737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0523539,
    stopColor: "#CBCBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1293,
    stopColor: "#D6D6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5381,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#D6D6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9551,
    stopColor: "#CBCBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_460_2818",
    x1: 64.4395,
    y1: 138.604,
    x2: 69.7326,
    y2: 138.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00285087,
    stopColor: "#838382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#B4B4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4342,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5381,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6634,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8318,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9041,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9714,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_460_2818",
    x1: 77.894,
    y1: 20.2889,
    x2: 103.924,
    y2: 20.2889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0AB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0475528,
    stopColor: "#F4B377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1526,
    stopColor: "#FAC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2789,
    stopColor: "#FEC88E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    stopColor: "#FFCA91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7698,
    stopColor: "#FEC88F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8733,
    stopColor: "#FBC288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#F6B87D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0AB6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_460_2818",
    x1: 90.9089,
    y1: 25.2451,
    x2: 90.9089,
    y2: 16.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#704528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_460_2818",
    x1: 81.6794,
    y1: 2.10066,
    x2: 100.387,
    y2: 20.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#704528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4975,
    stopColor: "#965D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_460_2818",
    x1: 71.408,
    y1: 86.8748,
    x2: 65.7024,
    y2: 86.3868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00864558,
    stopColor: "#FABD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#FDC895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2606,
    stopColor: "#FFCF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    stopColor: "#FFD1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7852,
    stopColor: "#FFD09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    stopColor: "#FDCA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9717,
    stopColor: "#FBC18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_460_2818",
    x1: 67.5714,
    y1: 96.1199,
    x2: 65.2369,
    y2: 95.9203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00864558,
    stopColor: "#FABD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#FDC895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2606,
    stopColor: "#FFCF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    stopColor: "#FFD1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7852,
    stopColor: "#FFD09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    stopColor: "#FDCA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9717,
    stopColor: "#FBC18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_460_2818",
    x1: 65.2798,
    y1: 95.4108,
    x2: 63.291,
    y2: 95.2407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00864558,
    stopColor: "#FABD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#FDC895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2606,
    stopColor: "#FFCF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    stopColor: "#FFD1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7852,
    stopColor: "#FFD09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    stopColor: "#FDCA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9717,
    stopColor: "#FBC18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_460_2818",
    x1: 69.9044,
    y1: 96.3249,
    x2: 67.57,
    y2: 96.1253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00864558,
    stopColor: "#FABD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#FDC895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2606,
    stopColor: "#FFCF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    stopColor: "#FFD1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7852,
    stopColor: "#FFD09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    stopColor: "#FDCA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9717,
    stopColor: "#FBC18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_460_2818",
    x1: 72.2386,
    y1: 96.5308,
    x2: 69.9043,
    y2: 96.3311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00864558,
    stopColor: "#FABD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#FDC895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2606,
    stopColor: "#FFCF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    stopColor: "#FFD1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7852,
    stopColor: "#FFD09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    stopColor: "#FDCA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9717,
    stopColor: "#FBC18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_460_2818",
    x1: 68.68,
    y1: 85.1668,
    x2: 67.7784,
    y2: 95.4194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2284,
    stopColor: "#FFD1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6799,
    stopColor: "#FFD09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8422,
    stopColor: "#FDCA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9578,
    stopColor: "#FBC18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_460_2818",
    x1: 63.7434,
    y1: 89.8987,
    x2: 72.7413,
    y2: 90.6682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000568506,
    stopColor: "#D99965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0284187,
    stopColor: "#E2B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058921,
    stopColor: "#EAC6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0934721,
    stopColor: "#F0D8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1325,
    stopColor: "#F6E6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1781,
    stopColor: "#FAF1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#FDF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3135,
    stopColor: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6947,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7673,
    stopColor: "#FDF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FAF0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8678,
    stopColor: "#F5E4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#EFD5BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    stopColor: "#E8C2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9769,
    stopColor: "#E0AB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99864"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_460_2818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.1948,
    height: 169.487,
    fill: "white",
    transform: "translate(39.2812 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalaccident);
export default __webpack_public_path__ + "static/media/personalaccident.9a7a3405d558fe1e1ecb65dfbbfe25b9.svg";
export { ForwardRef as ReactComponent };